/*
 * Jira Ticket:
 * Created Date: Tue, 17th Mar 2020, 11:15:50 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

const setFilter = ({
  filter,
  setResourceFilter,
  currentFilter,
  checkFilterValues,
}) => {
  if (filter) {
    if (checkFilterValues(currentFilter, filter)) {
      const filterName = filter.name.split('_')[1];
      if (filter.value && filter.value.length > 0) {
        return setResourceFilter({
          [filterName]: filter.value,
        });
      }
      return setResourceFilter({ [filterName]: null });
    }
  }
  return setResourceFilter({});
};

export default setFilter;
